import classes from './input.module.css';

const Select = ({
	customClass,
	isTouched,
	isValid,
	errorMessage,
	attributes,
	options,
	value,
	valueChangeHandler,
	inputBlurHandler
}) => {

	// Set default class and add customClass conditionally
	const styles = ['bg-transparent focus:outline-none']; // default class

	if (customClass) {
		styles.push(customClass); // add customClass if provided
	}

	if (isTouched && isValid && errorMessage) {
		styles.push(classes.invalid); // add invalid class conditionally
	}

	const error = errorMessage ? <div className={`errorTxt`} >{errorMessage}</div> : null

	let dropdown = options && options.length > 0 ? options.map(option => (<option key={option.id} value={option.value} >{option.text}</option>)) : null;

	return (
		<>
			<select
				className={`${styles.join(' ')} select-placeholder`}
				{...attributes}
				value={value}
				onChange={valueChangeHandler}
				onBlur={inputBlurHandler}

			>
				<option value="" >{`${attributes.placeholder}`}</option>
				{dropdown}
			</select>
			{error}
		</>
	);
};

export default Select;